import React, {useEffect, useState} from 'react';
import {useTranslation} from 'react-i18next';
import {ConfirmationModalPromise, MainLoader} from '@components';
import {StyledH3, WhiteButton, StyledH4} from '@styled';
import {useDispatch, useSelector} from 'react-redux';
// import {useHistory} from 'react-router-dom';
import styled from 'styled-components';
import {Row, Col} from 'react-bootstrap';
import moment from 'moment';
import {sagaActions} from './redux/saga';
import DownloadAndViewReport from './DownloadAndViewReport';
import ManageComments from './ManageComments';

const StyledHeadRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  .heading {
  }
  .actions {
  }
`;
const StyledRow = styled(Row)`
  background: #ffffff;
  box-shadow: 0px 1px 3px rgba(38, 38, 65, 0.1);
  border-radius: 5px;
`;
const StyledCol = styled(Col)`
  padding: 0.4em 0.6em;
`;

const StyledSectionWrapper = styled.div`
  padding-left: 10px;
  padding-right: 10px;
`;

const STATUSES_LABEL = {
  Pending: 'Pending',
  Active: 'Under reviewing',
  Approved: 'Approved',
  Rejected: 'Rejected',
};

const SubmittedReportRow = ({report, submittedOn, reportTitle}) => {
  const [viewReport, toggleViewReport] = useState(false);

  return (
    <div key={`sbt_rep_${report.id}`}>
      <StyledRow>
        <StyledCol lg={9} className="align-self-center">
          {reportTitle}
        </StyledCol>
        <StyledCol lg={2} className="align-self-center">
          {submittedOn}
        </StyledCol>
        <StyledCol lg={1}>
          <WhiteButton
            className="mr-1"
            onClick={() => toggleViewReport(!viewReport)}
          >
            {!viewReport ? 'View' : 'Hide'}
          </WhiteButton>
        </StyledCol>
      </StyledRow>
      {viewReport ? <DownloadAndViewReport reportId={report.id} /> : null}
    </div>
  );
};

const AnnualReports = () => {
  const [t] = useTranslation();
  const dispatch = useDispatch();
  const [showUnSubmittedReport, toggleShowUnSubmittedReport] = useState(false);
  const [showUnSubmittedReportComments, toggleShowUnSubmittedReportComments] =
    useState(false);
  const isLoading = useSelector((state) => state.reports.loading);
  const unSubmittedReports = useSelector((state) =>
    state.reports.annualReports.filter(
      (report) =>
        !report.isSubmitted ||
        (report.isSubmitted && report.status !== 'Approved')
    )
  );
  const submittedReports = useSelector((state) =>
    state.reports.annualReports.filter(
      (report) => report.isSubmitted && report.status === 'Approved'
    )
  );

  const reportYear = new Date().getFullYear();

  const {defaultCorporate, corporates} = useSelector((state) => {
    if (state.layout.corporateStructure.length) {
      return {
        corporates: state.layout.corporateStructure,
        defaultCorporate: state.layout.corporateStructure[0],
      };
    }
    return {corporates: [], defaultCorporate: null};
  });

  useEffect(() => {
    dispatch({type: sagaActions.FETCH_ANNUAL_REPORTS, payload: {}});
  }, []);

  const handleGenerateReport = () => {
    const corporateId = defaultCorporate ? defaultCorporate.id : 0;
    if (corporateId) {
      dispatch({
        type: sagaActions.GENERATE_ANNUAL_REPORTS,
        payload: {
          corporateId,
          reportYear,
        },
      });
    }
  };

  const handleSubmitReport = (report) => {
    ConfirmationModalPromise({
      title: `Are you sure you want to submit the generated report?`,
      show: true,
      confirmBtn: 'Yes',
      cancelBtn: 'No',
      headTitle: 'Confirmation!',
    }).then(
      () => {
        dispatch({
          type: sagaActions.SUBMIT_ANNUAL_REPORT,
          payload: {reportId: report.id, corporateId: report.corporateId},
        });
      },
      () => {
        //  do nothing on failure
      }
    );
  };

  const hasSubmittedCurrentYearReport = React.useCallback(() => {
    const corporateId = defaultCorporate ? defaultCorporate.id : 0;
    const alreadySubmitted = submittedReports
      .concat(unSubmittedReports)
      .find(
        (report) =>
          report.corporateId === corporateId &&
          String(report.reportYear) === String(reportYear)
      );

    return alreadySubmitted ? true : false;
  }, [submittedReports, unSubmittedReports, defaultCorporate, reportYear]);

  const genReportTitle = (report) => {
    const corporate = corporates.find((corp) => corp.id === report.corporateId);
    return `${report.reportYear} ${
      corporate ? corporate.name : ''
    } Annual Report`;
  };

  const handleRemoveReport = (report) => {
    ConfirmationModalPromise({
      title: `Are you sure you want to remove the generated report?`,
      show: true,
      confirmBtn: 'Yes',
      cancelBtn: 'No',
      headTitle: 'Confirmation!',
    }).then(
      () => {
        dispatch({
          type: sagaActions.REMOVE_ANNUAL_REPORT,
          payload: {reportId: report.id, corporateId: report.corporateId},
        });
      },
      () => {
        //  do nothing on failure
      }
    );
  };

  const renderUnsubmittedReport = () => {
    if (unSubmittedReports.length) {
      return unSubmittedReports.map((report) => (
        <div key={`unsubmitted-report-${report.id}`}>
          <StyledRow>
            <StyledCol lg={6} className="align-self-center">
              {genReportTitle(report)}
            </StyledCol>
            <StyledCol lg={6} className="text-right">
              {!report.isSubmitted ? (
                <>
                  <WhiteButton
                    className="mr-1"
                    size="sm"
                    onClick={() => handleSubmitReport(report)}
                  >
                    Submit
                  </WhiteButton>
                  <WhiteButton
                    className="mr-1"
                    size="sm"
                    onClick={() => handleRemoveReport(report)}
                  >
                    Remove
                  </WhiteButton>
                  {/* <WhiteButton className="ml-1" size="sm">
                    Add/Edit Attachments
                  </WhiteButton> */}
                </>
              ) : (
                <>
                  {/* <WhiteButton className="mr-1" size="sm">
                    Add/Edit Attachments
                  </WhiteButton> */}
                  <WhiteButton
                    className="mr-1"
                    size="sm"
                    onClick={() => handleGenerateReport(report)}
                  >
                    Update/Re-Generate?
                  </WhiteButton>

                  <span className="mx-3">
                    {STATUSES_LABEL[report.status] || report.status}
                  </span>
                </>
              )}
              <WhiteButton
                className="ml-1"
                onClick={() =>
                  toggleShowUnSubmittedReportComments(
                    !showUnSubmittedReportComments
                  )
                }
              >
                {showUnSubmittedReportComments
                  ? 'Hide Comments'
                  : 'View Comments'}
              </WhiteButton>
              <WhiteButton
                className="ml-1"
                onClick={() =>
                  toggleShowUnSubmittedReport(!showUnSubmittedReport)
                }
              >
                {showUnSubmittedReport ? 'Hide' : 'View'}
              </WhiteButton>
            </StyledCol>
          </StyledRow>
          {showUnSubmittedReportComments ? (
            <ManageComments reportId={report.id} />
          ) : null}
          {showUnSubmittedReport ? (
            <DownloadAndViewReport reportId={report.id} />
          ) : null}
        </div>
      ));
    }
    if (!hasSubmittedCurrentYearReport()) {
      return (
        <StyledRow>
          <StyledCol lg={9} className="align-self-center">
            {genReportTitle({
              reportYear,
              corporateId: defaultCorporate ? defaultCorporate.id : 0,
            })}
          </StyledCol>
          <StyledCol lg={3} className="text-right">
            {/* <WhiteButton className="mr-1" size="sm">
              Add/Edit Attachments
            </WhiteButton> */}
            <WhiteButton
              className="mr-1"
              onClick={() => handleGenerateReport()}
              size="sm"
            >
              Generate
            </WhiteButton>
          </StyledCol>
        </StyledRow>
      );
    }
    return (
      <StyledRow>
        <StyledCol>
          Current year report already submitted for ({defaultCorporate.name})
        </StyledCol>
      </StyledRow>
    );
  };

  return (
    <>
      {isLoading && (
        <MainLoader
          minHeight="100vh"
          spinnerColor="#479541"
          background="rgba(0,0,0,0.2)"
        />
      )}
      <div>
        <StyledHeadRow>
          <StyledH3>{t('reports.annualReports.pageHeading')}</StyledH3>
        </StyledHeadRow>
        <div className="mt-3">
          <StyledH4>{t('reports.annualReports.unsubmittedReports')}</StyledH4>
          <StyledSectionWrapper>
            {renderUnsubmittedReport()}
          </StyledSectionWrapper>
        </div>
        <div className="mt-3">
          <StyledH4>{t('reports.annualReports.submittedReports')}</StyledH4>
          <StyledSectionWrapper>
            {submittedReports.length ? (
              submittedReports.map((report) => {
                const submittedOn = `Submitted on ${moment(
                  report.submittedOn
                ).format('DD/MM/YYYY')}`;
                const reportTitle = genReportTitle(report);
                return (
                  <SubmittedReportRow
                    report={report}
                    submittedOn={submittedOn}
                    reportTitle={reportTitle}
                  />
                );
              })
            ) : (
              <StyledRow>
                <StyledCol>No report submitted yet!</StyledCol>
              </StyledRow>
            )}
          </StyledSectionWrapper>
        </div>
      </div>
    </>
  );
};

export default AnnualReports;
